<template>
  <fieldset class="va-info-field-wrapper">
    <span :style="{ color: labelColor }" class="va-input-label">{{ label }}</span>
    <span class="w-full">
      <div class="flex">
        <VaButtonToggle v-model="inputValue" :options="options" :color="color" :toggle-color="toggleColor" gradient />
      </div>
    </span>
  </fieldset>
</template>

<script setup lang="ts">
import { PropType, ref, watch } from "vue"

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  options: {
    type: Array as PropType<Array<{ label: string; value: string }>>,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: "#7485A9", // Default color for the selected button
  },
  toggleColor: {
    type: String,
    default: "primary", // Default color for the toggle button
  },
  labelColor: {
    type: String,
    default: "var(--va-primary)", // Default color for the label
  },
})
const inputValue = ref(props.modelValue)
const emit = defineEmits(["update:modelValue"])
watch(
  () => props.modelValue,
  (val) => {
    inputValue.value = val
  },
)

watch(inputValue, (val) => {
  emit("update:modelValue", val)
})
</script>
